<template>
	<div>
		<input type="checkbox" class="mycheck" :checked="params.value" @click="checkedHandler($event)" />
		<span class="checkmark"></span>
	</div>
</template>

<script>
export default {
	name: "CellRendererCheckDelivery",
	methods: {
		checkedHandler(event) {
			let checked = event.target.checked;
			let colId = this.params.column.colId;
			this.params.node.setDataValue(colId, checked);
			if (checked) {
				this.params.data.isDelivery = true;
				this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS", this.params.data);
			} else {
				this.params.data.isDelivery = false;
				this.$store.commit("moduleVisitPoint/REMOVE_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS", this.params.data);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.mycheck {
	cursor: pointer;
	background-color: #fff;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
	width: 16px;
	height: 16px;
	appearance: none;
	border: 1px solid #888;
	transition: background-color 0.3s ease-in-out;
}

.mycheck:checked {
	background-color: rgba(var(--vs-warning), 1);
}

.mycheck:focus {
	border-color: rgb(80, 67, 250);
}

.mycheck:disabled {
	background-color: #ccc;
	background-image: none;
}

.mycheck:disabled:checked {
	background-color: #ccc;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
}
</style>
